export default {
	auth: {
		token: null
	},
	allocations: {
		byIds: {},
		isFetching: null
	},
	religions: {
		byIds: {},
		isFetching: null
	},
	states: {
		byIds: {},
		isFetching: null
	},
	politicalAffiliations: {
		byIds: {},
		isFetching: null
	},
	settings: {
		isFetching: null
	},
	stats: {
		isFetching: null
	},
	userData: {
		isFetching: null
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/initialState.js